import Image from 'next/image';

type MenuItemProps = {
    text: string,
    src?: string
}

export default function MenuItem({text, src}: MenuItemProps) {
    return (
        <div className="flex gap-6 justify-between items-center">
            <div className="flex justify-center items-center w-13 h-13 border border-grey-02 rounded-[5px] bg-dark-05">
                {src && <Image
                    src={src}
                    width={20}
                    height={20}
                    alt={""}
                    style={{
                        objectFit: 'cover'
                    }}>
                </Image>
                }
            </div>
            {text && <span className="text-white text-[24px] uppercase flex-1">{text}</span>}
        </div>
    );
}